<template>
  <div>
    <surveys-table
      surveyName="CDLQI"
      surveyCode="CDLQI"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_CDLQI,
        viewDetail: permissions.SEE_DETAIL_SURVEY_CDLQI,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
